export const LAMBDA_WEB_HELLO_WORLD_FILES: Record<string, string> = {
  'index.js': `import { createServer } from 'node:http';
import { readFileSync } from 'node:fs';

const [host, port] = (process.env.AWS_LAMBDA_HTTP_ENDPOINT || '0.0.0.0:3000').split(':');

createServer((request, response) => {
  if (request.url === '/hello-world') {
    response.writeHead(200, { 'Content-Type': 'application/json' });
    response.end(JSON.stringify({
      message: 'Hello from LocalStack!',
      timestamp: new Date().toISOString(),
      status: 'success',
    }));
  } else {
    response.writeHead(200, { 'Content-Type': 'text/html' });
    response.end(readFileSync(new URL('./index.html', import.meta.url)));
  }
}).listen(Number(port), host);
`,
  'index.html': `<!doctype html>
<html lang="en">
  <head><meta charset="utf-8"><title>Lambda Web Function</title></head>
  <body>
    <h1>Hello from LocalStack!</h1>
    <p>Your HTTP server is running.</p>
    <a href="/hello-world">View the JSON response</a>
  </body>
</html>
`,
  'package.json': JSON.stringify(
    {
      name: 'web-function',
      version: '1.0.0',
      type: 'module',
      main: 'index.js',
      scripts: { dev: 'node index.js' },
    },
    null,
    2,
  ),
};

export const LAMBDA_WEB_MIN_VERSION = '2026.10.0';
export { LAMBDA_WEB_HELLO_WORLD_ZIP_BASE64 } from '../lambdawebTemplate.generated';
